import React from 'react'
import { mount } from 'enzyme'
import ModalHeader from '../ModalHeader'

describe('<ModalHeader />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      text: 'Test',
      onClose: jest.fn(),
      closeButtonId: 'test_id'
    }
    wrapper = mount(<ModalHeader {...props} />)
  })
  it('should render the provided header text', () => {
    expect(wrapper.find('h2').text()).toEqual(props.text)
  })
  it('should call its onClose prop when the close button is clicked', () => {
    // Enzyme attaches the id prop to the custom component automattically (terrible default behavior if you ask me)
    // so in order to prevent find() from returning two elements, we use getHostNodes()
    wrapper.find(`#${props.closeButtonId}`).hostNodes().simulate('click')
    expect(props.onClose).toHaveBeenCalledTimes(1)
  })
  it('should set the close button\'s id to its closeButtonId prop', () => {
    expect(wrapper.find(`#${props.closeButtonId}`).hostNodes()).toHaveLength(1)
  })
})